/* HH PDP extras — round 1
   Custom review snippet card (design "quote card"):
   Loox's snippets widget renders in shadow DOM with a fixed 48px arrow lane,
   so its card can never span the full buy-box column. We read the review
   content from the widget's OPEN shadow root and render our own light-DOM
   card instead; the widget is then hidden. If extraction fails (Loox markup
   change, no reviews), nothing is hidden and the styled Loox card remains
   as the fallback. */
(function () {
  'use strict';

  function extractSlide(el) {
    if (!el) return null;
    var img = el.querySelector('img');
    var stars = el.querySelectorAll('svg[data-lx-fill="full"], .rating svg').length;
    // name node: Loox marks it with a class containing "name"
    var nameEl = el.querySelector('[class*="name"]');
    var name = nameEl ? nameEl.textContent.trim() : '';
    // the quote = the longest LEAF text in the slide (wrapper nodes contain name + quote mixed)
    var text = '';
    el.querySelectorAll('*').forEach(function (n) {
      if (n.children.length === 0) {
        var t = n.textContent.trim();
        if (t.length > text.length && t !== name) text = t;
      }
    });
    if (!text || text.length < 8) return null;
    return {
      img: img ? img.src : null,
      name: name,
      text: text,
      stars: stars > 0 && stars <= 5 ? stars : 5,
    };
  }

  function buildCard(review, index, count) {
    var card = document.createElement('a');
    card.className = 'hh-snip';
    card.href = '#looxReviews';
    card.setAttribute('aria-label', 'Review ' + (index + 1) + ' of ' + count + '. Read all customer reviews');
    card.setAttribute('aria-roledescription', 'slide');

    var quote = document.createElement('span');
    quote.className = 'hh-snip__qm';
    quote.setAttribute('aria-hidden', 'true');
    quote.textContent = '“';
    card.appendChild(quote);

    if (review.img) {
      var image = document.createElement('img');
      image.className = 'hh-snip__img';
      image.src = review.img;
      image.alt = '';
      image.loading = 'lazy';
      card.appendChild(image);
    }

    var body = document.createElement('span');
    body.className = 'hh-snip__body';
    var head = document.createElement('span');
    head.className = 'hh-snip__head';
    var name = document.createElement('b');
    name.textContent = review.name || 'Verified customer';
    var stars = document.createElement('span');
    stars.className = 'hh-snip__stars';
    stars.setAttribute('aria-hidden', 'true');
    stars.textContent = new Array(review.stars + 1).join('★');
    var text = document.createElement('span');
    text.className = 'hh-snip__text';
    text.textContent = review.text;
    head.appendChild(name);
    head.appendChild(stars);
    body.appendChild(head);
    body.appendChild(text);
    card.appendChild(body);
    return card;
  }

  function buildCarousel(reviews) {
    var carousel = document.createElement('div');
    carousel.className = 'hh-snip-carousel';
    carousel.setAttribute('role', 'region');
    carousel.setAttribute('aria-roledescription', 'carousel');
    carousel.setAttribute('aria-label', 'Customer review highlights');

    var viewport = document.createElement('div');
    viewport.className = 'hh-snip-viewport';
    viewport.tabIndex = 0;
    reviews.forEach(function (review, index) {
      viewport.appendChild(buildCard(review, index, reviews.length));
    });
    carousel.appendChild(viewport);

    if (reviews.length < 2) return carousel;

    var previous = document.createElement('button');
    previous.type = 'button';
    previous.className = 'hh-snip-nav hh-snip-nav--prev';
    previous.setAttribute('aria-label', 'Previous review');
    previous.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m12.5 4.5-5.5 5.5 5.5 5.5"/></svg>';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'hh-snip-nav hh-snip-nav--next';
    next.setAttribute('aria-label', 'Next review');
    next.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7.5 4.5 5.5 5.5-5.5 5.5"/></svg>';

    var dots = document.createElement('div');
    dots.className = 'hh-snip-dots';
    dots.setAttribute('aria-label', 'Choose review');
    var dotButtons = reviews.map(function (_, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Show review ' + (index + 1));
      dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      dots.appendChild(dot);
      return dot;
    });

    var status = document.createElement('span');
    status.className = 'visually-hidden';
    status.setAttribute('aria-live', 'polite');
    status.textContent = 'Review 1 of ' + reviews.length;

    carousel.appendChild(previous);
    carousel.appendChild(next);
    carousel.appendChild(dots);
    carousel.appendChild(status);

    var active = 0;
    var scrollTimer;
    function update(index, announce) {
      active = Math.max(0, Math.min(reviews.length - 1, index));
      dotButtons.forEach(function (dot, dotIndex) {
        dot.setAttribute('aria-current', dotIndex === active ? 'true' : 'false');
      });
      if (announce) status.textContent = 'Review ' + (active + 1) + ' of ' + reviews.length;
    }
    function go(index) {
      var target = (index + reviews.length) % reviews.length;
      update(target, true);
      viewport.scrollTo({ left: target * viewport.clientWidth, behavior: 'smooth' });
    }

    previous.addEventListener('click', function () { go(active - 1); });
    next.addEventListener('click', function () { go(active + 1); });
    dotButtons.forEach(function (dot, index) {
      dot.addEventListener('click', function () { go(index); });
    });
    viewport.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        update(Math.round(viewport.scrollLeft / Math.max(1, viewport.clientWidth)), true);
      }, 80);
    }, { passive: true });
    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(active - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); go(active + 1); }
    });

    return carousel;
  }

  function init() {
    var host = document.querySelector('.products_info loox-snippets-widget');
    if (!host) return true; // nothing to do on this page
    var sr = host.shadowRoot;
    if (!sr) return false;
    var reviews = [];
    var seen = Object.create(null);
    sr.querySelectorAll('.element').forEach(function (slide) {
      if (reviews.length >= 3) return;
      var review = extractSlide(slide);
      if (!review) return;
      var key = review.name + '|' + review.text;
      if (seen[key]) return;
      seen[key] = true;
      reviews.push(review);
    });
    if (!reviews.length) return false;
    var block = host.closest('.shopify-app-block') || host;
    if (block.parentElement.querySelector('.hh-snip-carousel')) return true;
    block.parentElement.insertBefore(buildCarousel(reviews), block);
    block.classList.add('hh-snip-source-hidden');
    return true;
  }

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (init() || tries > 30) clearInterval(timer);
  }, 400);

  /* ---------------------------------------------------------------
     Description: pull the Breed/Gender chips out of the description
     HTML (they are hardcoded inline-styled spans inside it), then
     clamp the remaining copy to 2 lines with a Read more toggle.
     Purchase-relevant facts must never hide inside the clamp.
  --------------------------------------------------------------- */
  function initDescription() {
    var desc = document.querySelector('.products_info .main-product_description-block');
    if (!desc || desc.dataset.hhDone) return;
    if (desc.dataset.hhClamp !== 'true') return; // merchant switched the clamp off
    desc.dataset.hhDone = '1';

    // 1) chips: the description's flex row of pill spans (Breed:, Gender: ...)
    var chipRow = null;
    desc.querySelectorAll('div').forEach(function (div) {
      if (chipRow) return;
      var st = (div.getAttribute('style') || '').replace(/\s/g, '');
      var spans = div.querySelectorAll('span');
      if (st.indexOf('display:flex') > -1 && spans.length > 0 && div.querySelector('strong')) {
        chipRow = div;
      }
    });

    // 2) clamp wrapper around whatever copy is left
    var copy = document.createElement('div');
    copy.className = 'hh-desc';
    while (desc.firstChild) {
      if (desc.firstChild === chipRow) { desc.removeChild(chipRow); continue; }
      copy.appendChild(desc.firstChild);
    }
    desc.appendChild(copy);

    if (chipRow) {
      chipRow.removeAttribute('style');
      chipRow.classList.add('hh-chips');
      chipRow.querySelectorAll('span').forEach(function (s) { s.removeAttribute('style'); });
      desc.appendChild(chipRow);
    }

    // 3) Read more, only when the copy actually overflows the clamp
    requestAnimationFrame(function () {
      if (copy.scrollHeight - copy.clientHeight < 6) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hh-desc__more';
      var labelMore = desc.dataset.moreLabel || 'Read more';
      var labelLess = desc.dataset.lessLabel || 'Read less';
      btn.textContent = labelMore;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = copy.classList.toggle('hh-desc--open');
        btn.textContent = open ? labelLess : labelMore;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      copy.insertAdjacentElement('afterend', btn);
    });
  }

  if (document.readyState !== 'loading') initDescription();
  else document.addEventListener('DOMContentLoaded', initDescription);

  /* ---------------------------------------------------------------
     Klarna: the app block can only be ordered as a whole block, which
     lands it under the size cards (price + variants are one block).
     Move it up so the BNPL line sits directly under the price.
  --------------------------------------------------------------- */
  function initKlarna() {
    var placement = document.querySelector('.products_info klarna-placement');
    if (!placement) return false;
    var block = placement.closest('.shopify-app-block') || placement.closest('.main-product_type-block');
    if (!block || block.dataset.hhMoved) return true;
    // the price <li> is a flex row (label | value): append INSIDE the value column
    // so the Klarna line stacks under the price instead of beside it
    var priceCol = document.querySelector('.products_info .main-product_paver-list > li:first-child .paver-list_description');
    if (!priceCol) return true;
    block.dataset.hhMoved = '1';
    block.classList.add('hh-klarna');
    priceCol.appendChild(block);
    return true;
  }

  var kTries = 0;
  var kTimer = setInterval(function () {
    kTries++;
    if (initKlarna() || kTries > 40) clearInterval(kTimer);
  }, 400);

  /* ---------------------------------------------------------------
     Round 3
  --------------------------------------------------------------- */

  /* Modern purchase row: default to one item on the PDP, keep the quantity
     input in the DOM (so the form still submits quantity 1) but remove it from
     the visible layout. Quantity is adjusted in the cart drawer after adding. */
  function initBuyRow() {
    var qty = document.querySelector('.products_info .main-product_quantity_input-block');
    var holder = document.querySelector('.products_info .main-product_buttons-block .button_form-holder');
    if (qty) qty.setAttribute('aria-hidden', 'true');
    if (holder) holder.classList.add('hh-purchase-row');
  }

  /* (the in-stock line is rendered server-side inside the delivery card by
     snippets/hh-estimated-delivery.liquid — no JS relocation, no flash) */

  /* (payment icons: all methods are shown, ordered in Liquid — no fold, no JS) */

  function initRound3() {
    initBuyRow();
  }

  var r3 = 0;
  var r3Timer = setInterval(function () {
    r3++;
    initRound3();
    if (r3 > 20) clearInterval(r3Timer);
  }, 400);
  if (document.readyState !== 'loading') initRound3();
  else document.addEventListener('DOMContentLoaded', initRound3);
})();
